import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { PessoaJuridica } from "src/app/model/pessoa-juridica.model";
import { ResultadoPaginado } from "src/app/model/resultado";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

export interface FiltroPessoaJuridica {
  nome?: string;
  sigla?: string;
  cnpj?: string;
  limite?: number;
  pagina?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PessoasJuridicasService extends FgiBackEndService<PessoaJuridica>{

  getNewEntity(): PessoaJuridica {
    return new PessoaJuridica();
  }

  protected getResourceURL(): string {
    return 'front/pessoasjuridicas';
  }

  buscar(filtro: FiltroPessoaJuridica) {
    let params = new HttpParams();
    if (filtro.nome != null) {
      params = params.append("nome", filtro.nome);
    }
    if (filtro.sigla != null) {
      params = params.append("sigla", filtro.sigla);
    }
    if (filtro.cnpj != null) {
      params = params.append("cnpj", filtro.cnpj);
    }
    if (filtro.pagina != null) {
      params = params.append("pagina", filtro.pagina);
    }
    if (filtro.limite != null) {
      params = params.append("limite", filtro.limite);
    }
    console.log('params', params)
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}`, { ...options, params }).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<PessoaJuridica>>;
  }

  buscarNomes() {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/nomes`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<string>>;
  }

  buscarSiglas() {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/siglas`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<string>>;
  }

}
